/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Dmitrii: my namespace for A/B, custom GA events etc.
window.fk = window.fk || {};
window.fk.DOMReady = function(callback) {
  document.readyState === "interactive" || document.readyState === "complete" ? callback() : document.addEventListener("DOMContentLoaded", callback);
};
window.fk.windowLoad = function(callback) {
  document.readyState === "complete" ? callback() : window.addEventListener("load", callback);
};
window.fk.getURLParam =  function(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}
window.fk.isURLParam = function (parameterName) {
  // console.log('findParameter invoked:');
  // console.log(location.search.substr(1));
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item) {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = true;
    });
  return result;
};

window.fk.bookNowDecreaseQuantity = function() {
  let qty = document.querySelector('.BookNowPopup .QuantitySelector__CurrentQuantity');
  qty.value = Math.max(parseInt(qty.value) - 1, 0);
};
window.fk.bookNowIncreaseQuantity = function() {
  let qty = document.querySelector('.BookNowPopup .QuantitySelector__CurrentQuantity');
  qty.value = parseInt(qty.value) + 1;
};
window.fk.bookNowClose = function() {
  let bookNow = document.querySelector('.BookNowPopup');
  bookNow.setAttribute('aria-hidden', 'true');
};
window.fk.bookNowOpen = function(event) {
  let bookNow = document.querySelector('.BookNowPopup');
  bookNow.setAttribute('aria-hidden', 'false');

  let checkin_wrap = document.querySelector('.yacht-switch');
  let checkin_label = checkin_wrap ? checkin_wrap.querySelector('.Form__FloatingLabel') : null;
  let checkin_input = checkin_wrap ? checkin_wrap.querySelector('input') : null;
  let checkout_input = document.querySelector('.yacht-hide input');
  let qty_input = bookNow.querySelector('.QuantitySelector__CurrentQuantity')
  let property_link_elm = document.querySelector('#book_now_property');
  let bookNowBtn = bookNow.querySelector('.Button--primary');

  // console.log(property_link_elm.value);

  if ( (event && (event.target.dataset.productLink && event.target.dataset.productLink.includes('yacht'))) || property_link_elm.value.includes('yacht') ) {
    // make "book now" form yacht-specific
    bookNow.classList.add('yacht');
    checkout_input.setAttribute('disabled', 'disabled');
    checkin_label.textContent = 'Date';
    checkin_input.name = 'contact[date]';
  } else if ( event && event.target.dataset.productLink && (event.target.dataset.productLink.includes('wedding') || event.target.dataset.productLink.includes('concierge')) ) {
    // make "book now" form wedding-specific
    bookNow.classList.add('wedding-or-concierge');
    checkin_input.setAttribute('disabled', 'disabled');
    checkout_input.setAttribute('disabled', 'disabled');
    qty_input.setAttribute('disabled', 'disabled');
    bookNowBtn.textContent = 'Send contact request';

  } else {
    if ( bookNow.classList.contains('yacht') ) {
      bookNow.classList.remove('yacht');
      checkout_input.removeAttribute('disabled');
      checkin_label.textContent = checkin_label.dataset.textContent;
      checkin_input.name = 'contact[checkin]';
    }
    if ( bookNow.classList.contains('wedding-or-concierge') ) {
      bookNow.classList.remove('wedding-or-concierge');
      checkin_input.removeAttribute('disabled', 'disabled');
      checkout_input.removeAttribute('disabled', 'disabled');
      qty_input.removeAttribute('disabled', 'disabled');
      bookNowBtn.textContent = 'Send request';
    }
  }
  if ( event && event.target.dataset.productLink ) {
    console.log('Replacing product link with ' + event.target.dataset.productLink);
    property_link_elm.value = event.target.dataset.productLink;
  }

};

window.fk.initBookNow = function() {
  let triggers = document.querySelectorAll('[data-action="book-now"]');
  triggers.forEach(function(elm, index){
    elm.addEventListener('click',fk.bookNowOpen);
  });
  let bookNowCloseBtns = document.querySelectorAll('.BookNowPopup [data-action="close-modal"]');
  bookNowCloseBtns.forEach(function (elm, index){
    let pLink = '';
    if (elm.dataset.productLink) plink = elm.dataset.productLink;
    elm.addEventListener('click', fk.bookNowClose);
  });
  if ( fk.isURLParam('contact_posted') ) {
    fk.bookNowOpen();
  }

  let minusQtyBtn = document.querySelector('.BookNowPopup [data-action="decrease-quantity"]');
  if (minusQtyBtn) minusQtyBtn.addEventListener('click', fk.bookNowDecreaseQuantity);
  let plusQtyBtn = document.querySelector('.BookNowPopup [data-action="increase-quantity"]');
  if (plusQtyBtn) plusQtyBtn.addEventListener('click', fk.bookNowIncreaseQuantity);
};
window.fk.initTimelineCarousels = function() {
  if (window.innerWidth < 641) {
    return false;
  }
  let carousels = document.querySelectorAll('.Timeline .Carousel');
  carousels.forEach(function(elm, index) {
    new Flickity(elm, {
      "prevNextButtons": true,
      "pageDots": false,
      "adaptiveHeight": true,
      "watchCSS": true,
      "dragThreshold": 8,
      "arrowShape": {"x0": 20, "x1": 60, "y1": 40, "x2": 60, "y2": 35, "x3": 25}
  });
  });
};

window.fk.safariMacInputDatePolyfill = function() {
  let dateInputSelector='input[type="date"]';
  let dateInput = document.querySelector(dateInputSelector);
  if ( dateInput && dateInput.type !== 'date') {
    var oCSS = document.createElement('link');
    oCSS.type='text/css'; oCSS.rel='stylesheet';
    oCSS.href='//ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/themes/base/jquery-ui.css';
    oCSS.onload= function() {
      var oJQ = document.createElement('script');
      oJQ.type='text/javascript';
      oJQ.src='//code.jquery.com/jquery-1.12.4.min.js';
      oJQ.onload=function() {
        var oJS = document.createElement('script');
        oJS.type='text/javascript';
        oJS.src='//ajax.googleapis.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js';
        oJS.onload=function() {
          $(dateInputSelector).datepicker({
            dateFormat: 'yy-mm-dd',
          });
        }
        document.body.appendChild(oJS);
      }
      document.body.appendChild(oJQ);
    }
    document.body.appendChild(oCSS);
  }
};

fk.DOMReady(fk.initBookNow);
fk.DOMReady(fk.initTimelineCarousels);
fk.windowLoad(fk.safariMacInputDatePolyfill);